// import {EntityService} from '../..//EntityService';
import {EntityService} from '../../../service/EntityService';

export class SecurityService extends EntityService {

  static entity = 'api/app/security';

}
